module.exports = __webpack_public_path__ + "img/W7042-tran.e6f81390.jpg";